/* Carry product context into Globo's product quote form, preserving edited drafts.
 * Only triggered by the product's Quick Quote button; never submits the form. */
(function () {
  'use strict';
  const sizeName = /^(?:[x]{0,2}small|medium|[x]{0,2}large|[2-7]xlarge|size \d+|\d+-\d+ years):$/i;
  const draftKey = 'oakdene-quote-prefill-65991';
  let context = '';
  let observer;
  let expiry;

  function notebookContext(builder) {
    const detail = window.notebookQuotes && window.notebookQuotes[builder.dataset.productId];
    const quote = detail && !detail.error && detail.quote;
    const options = detail && detail.options;
    const selected = quote && quote.selection;
    if (!selected || String(options?.product?.id) !== builder.dataset.productId
      || !Number.isSafeInteger(quote.unitIncVatCents) || quote.unitIncVatCents <= 0
      || !Number.isSafeInteger(quote.totalIncVatCents) || quote.totalIncVatCents !== quote.unitIncVatCents * selected.quantity) {
      return ['Notebook specification and price: awaiting confirmation'];
    }
    const paper = options.papers.find(function (item) { return item.id === selected.paperId; });
    const print = options.prints.find(function (item) { return item.id === selected.printId; });
    const cover = options.covers.find(function (item) { return item.id === selected.coverId; });
    if (!paper || !print || !cover) return ['Notebook specification and price: awaiting confirmation'];
    const money = function (cents) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100); };
    const parts = [
      'Quantity: ' + selected.quantity + ' notebooks',
      'Internal pages: ' + selected.pages + ' (' + (selected.pages / 2) + ' leaves)',
      'Internal paper: ' + paper.label,
      'Internal printing: ' + print.label,
      'Cover: ' + cover.label
    ];
    if (quote.wire) parts.push('Wire: ' + quote.wire.colour + ' (' + quote.wire.diameterMm + ' mm)');
    parts.push('Guide unit price: ' + money(quote.unitIncVatCents) + ' including VAT');
    parts.push('Guide total: ' + money(quote.totalIncVatCents) + ' including VAT');
    return parts;
  }

  function productContext(button) {
    const product = button.closest('product-info') || button.closest('.product__info-container');
    if (!product) return '';
    const title = product.querySelector('.product__title h1') || product.querySelector('h1');
    if (!title) return '';
    const sku = product.querySelector('.product__sku');
    const calculator = product.querySelector('#calculator');
    const parts = [title.textContent.trim()];
    if (sku) parts.push(sku.textContent.trim().replace(/\s+/g, ' '));
    const notebook = product.querySelector('[data-notebook-builder]');
    if (notebook) return parts.concat(notebookContext(notebook)).join(' | ');
    if (calculator) {
      const sizes = Array.from(calculator.querySelectorAll('input[type="number"][data-calcname]')).filter(function (input) {
        return sizeName.test(input.getAttribute('data-calcname')) && !input.hasAttribute('data-lookup');
      });
      const quantities = sizes.filter(function (input) { return Number.isSafeInteger(Number(input.value)) && Number(input.value) > 0; });
      if (sizes.length >= 2) {
        const total = quantities.reduce(function (sum, input) { return sum + Number(input.value); }, 0);
        if (total > 0) {
          parts.push('Quantity: ' + total);
          parts.push(quantities.map(function (input) {
            return input.getAttribute('data-calcname').replace(/:$/, '') + ': ' + input.value;
          }).join(', '));
        }
      } else {
        const quantity = calculator.querySelector('input[type="number"][data-cpc_isquantity="true"]');
        if (quantity && Number.isSafeInteger(Number(quantity.value)) && Number(quantity.value) > 0) parts.push('Quantity: ' + quantity.value);
      }
      const colour = Array.from(calculator.querySelectorAll('textarea, input[type="text"]')).find(function (input) {
        return /chosen.*colou?r/i.test((input.name || '') + ' ' + (input.getAttribute('data-calcname') || ''));
      });
      if (colour && colour.value.trim()) parts.push('Colour: ' + colour.value.trim());
      calculator.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
        if (/print location/i.test(radio.getAttribute('data-calcname') || '') && radio.getClientRects().length) {
          parts.push(radio.getAttribute('data-calcname') + ': ' + radio.value);
        }
      });
      calculator.querySelectorAll('select[data-calcname], textarea[data-calcname]').forEach(function (input) {
        if (/print (?:location|size)/i.test(input.getAttribute('data-calcname')) && input.value.trim() && input.getClientRects().length) {
          parts.push(input.getAttribute('data-calcname') + ': ' + input.value.trim());
        }
      });
    }
    return parts.join(' | ');
  }

  function prefill() {
    if (!context) return false;
    const form = document.getElementById('globo-formbuilder-65991');
    if (!form) return false;
    const input = form.querySelector('input[name="repeater-1[]"]');
    if (!input) return false;
    let previous = input.dataset.oakdeneQuotePrefill;
    // Globo restores drafts across product navigation. Remember only our generated
    // text so it can follow the next product without replacing a customer's edits.
    try { previous = previous || sessionStorage.getItem(draftKey); } catch (error) { /* Storage may be disabled. */ }
    if (!input.value.trim() || input.value === previous) {
      input.value = context;
      input.dataset.oakdeneQuotePrefill = context;
      try { sessionStorage.setItem(draftKey, context); } catch (error) { /* Prefill still works on this page. */ }
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest && event.target.closest('.quick-quote');
    if (!button) return;
    context = productContext(button);
    if (observer) observer.disconnect();
    clearTimeout(expiry);
    if (!context) return;
    prefill();
    // Globo can mount or restore a draft after the button's inline handler runs.
    observer = new MutationObserver(prefill);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(prefill, 0);
    setTimeout(prefill, 250);
    expiry = setTimeout(function () { observer.disconnect(); }, 5000);
  }, true);
})();
